// @ts-ignore: 'n' is declared but its value is never read. n is required so that it conforms to function type
var SIMPLE_PLURAL_RULE = function (n) {
    return 0;
};
var SINGULAR_PLURAL_RULE = function (n) {
    return n != 1 ? 1 : 0;
};
var ZERO_ONE_PLURAL_RULE = function (n) {
    return n > 1 ? 1 : 0;
};
var RUSSIAN_PLURAL_RULE = function (n) {
    return n % 10 === 1 && n % 100 !== 11
        ? 0
        : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
            ? 1
            : 2;
};
var PLURAL_FUNCTIONS = {
    ar: function (n) {
        return n === 0
            ? 0
            : n === 1
                ? 1
                : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                        ? 3
                        : n % 100 >= 11
                            ? 4
                            : 5;
    },
    bn: SINGULAR_PLURAL_RULE,
    ca: SINGULAR_PLURAL_RULE,
    cs: function (n) {
        return n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;
    },
    cy: function (n) {
        return n === 1 ? 0 : n === 2 ? 1 : n !== 8 && n !== 11 ? 2 : 3;
    },
    da: SINGULAR_PLURAL_RULE,
    de: SINGULAR_PLURAL_RULE,
    el: SINGULAR_PLURAL_RULE,
    en: SINGULAR_PLURAL_RULE,
    eo: SINGULAR_PLURAL_RULE,
    es: SINGULAR_PLURAL_RULE,
    fr: ZERO_ONE_PLURAL_RULE,
    ga: function (n) {
        return n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4;
    },
    gd: function (n) {
        return n === 1 || n === 11
            ? 0
            : n === 2 || n === 12
                ? 1
                : n !== 0 && n < 20
                    ? 2
                    : 3;
    },
    gn: SINGULAR_PLURAL_RULE,
    he: function (n) {
        return n === 1 ? 0 : n === 2 ? 1 : n > 10 && n % 10 === 0 ? 2 : 3;
    },
    hi: SINGULAR_PLURAL_RULE,
    ht: SINGULAR_PLURAL_RULE,
    hu: SINGULAR_PLURAL_RULE,
    hv: SINGULAR_PLURAL_RULE,
    hw: SINGULAR_PLURAL_RULE,
    id: SIMPLE_PLURAL_RULE,
    it: SINGULAR_PLURAL_RULE,
    ja: SIMPLE_PLURAL_RULE,
    ko: SIMPLE_PLURAL_RULE,
    la: SINGULAR_PLURAL_RULE,
    "nl-NL": SINGULAR_PLURAL_RULE,
    "no-BO": SINGULAR_PLURAL_RULE,
    nv: SINGULAR_PLURAL_RULE,
    pl: function (n) {
        return n === 1
            ? 0
            : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
                ? 1
                : 2;
    },
    pt: SINGULAR_PLURAL_RULE,
    ro: function (n) {
        return n === 1 ? 0 : n === 0 || (n % 100 > 0 && n % 100 < 20) ? 1 : 2;
    },
    ru: RUSSIAN_PLURAL_RULE,
    sv: SINGULAR_PLURAL_RULE,
    sw: SINGULAR_PLURAL_RULE,
    th: SIMPLE_PLURAL_RULE,
    tl: function (n) {
        return n % 10 === 4 || n % 10 === 6 || n % 10 === 9 ? 1 : 0;
    },
    tlh: SINGULAR_PLURAL_RULE,
    tr: ZERO_ONE_PLURAL_RULE,
    uk: RUSSIAN_PLURAL_RULE,
    vi: SIMPLE_PLURAL_RULE,
    yi: SINGULAR_PLURAL_RULE,
    zh: SIMPLE_PLURAL_RULE,
    "zh-HK": SIMPLE_PLURAL_RULE,
    zu: SINGULAR_PLURAL_RULE,
};

export { PLURAL_FUNCTIONS, SIMPLE_PLURAL_RULE };
